import './EnhancedEventViewSpecialEvent.scss';
import { useTranslation } from 'react-i18next';
import EnhancedEventViewReleaseEvent from '../EnhancedEventViewReleaseEvent/EnhancedEventViewReleaseEvent';
import { eventActivityType, eventTrainingList } from '../../../constants/myBlockMonth';
import { convertToDateObject, getDateInWeekDayMonthDateFormat } from '../../../helpers/dateHelpers';
import { formatNumToTime } from '../../../helpers/timeHelpers';
import { getEventBaseLocation, getEventTimezone } from '../../../pages/MyBlockMonth/myBlockMonthHelper';
import { useProfile } from '../../../providers/Profile';


const EnhancedEventViewSpecialEvent = ({ pairingEvent, eventType }) => {
  const { t } = useTranslation();
  const profileContext = useProfile();
  
  return (
    <>
      <div className="c-special-event-details">
        <div className={eventType === eventActivityType.RAP || pairingEvent.activityId === eventTrainingList.SCHOOL || pairingEvent.activityId === eventTrainingList.SIMTRAVEL ? 'c-detail c-detail--start c-detail--start--rap' : 'c-detail c-detail--start'}>
          <p className="event-details__label">{t('myBlockMonth.start')}</p>
          <p className="detail__date">{getDateInWeekDayMonthDateFormat(convertToDateObject(pairingEvent?.start_date, '00:00'))}</p>
          <p>{formatNumToTime(pairingEvent?.checkIn?.value)} {getEventTimezone(pairingEvent?.timezone)}</p>
        </div>
        <div className={eventType === eventActivityType.RAP || pairingEvent.activityId === eventTrainingList.SCHOOL || pairingEvent.activityId === eventTrainingList.SIMTRAVEL ? 'c-detail c-detail--end c-detail--end--rap' : 'c-detail c-detail--end'}>
          <p className="event-details__label">{t('myBlockMonth.end')}</p>
          <p className="detail__date">{getDateInWeekDayMonthDateFormat(convertToDateObject(pairingEvent?.end_date, '00:00'))}</p>
          <p>{formatNumToTime(pairingEvent?.checkOut?.value)} {getEventTimezone(pairingEvent?.timezone)}</p>
        </div>
        {(pairingEvent.activityId === eventTrainingList.SIM || pairingEvent.activityId === eventTrainingList.SIMTRAVEL) && (
          <div className="c-detail">
            <p className="event-details__label">{t('myBlockMonth.location')}</p>
            <p className="detail__location-value">{getEventBaseLocation(pairingEvent,profileContext)}</p>
          </div>
        )}
        {(eventType === eventActivityType.RAP || eventType === eventActivityType.RAPH) && (
          <div className="c-detail">
            <p className="event-details__label">{t('myBlockMonth.rapPilotPosition')}</p>
            <p className="detail__location-value">{pairingEvent?.RAPPilotPosition}</p>
          </div>
        )}
      </div>
      {(eventType === eventActivityType.DSP || eventType === eventActivityType.RAPH || eventType === eventActivityType.SICK_INS) && (
        <div className="c-event-details-remarks">
          <span className="displaced-event-remarks__header">{t('myBlockMonth.remarks')}
            {eventType === eventActivityType.RAPH ? <span className="displaced-event-remarks__values">{t('myBlockMonth.remarksRAPH')}</span>
              : eventType === eventActivityType.SICK_INS ? <span className="displaced-event-remarks__values">{t('myBlockMonth.remarksGDIP')}</span> 
              : eventType === eventActivityType.DSP && <span className="displaced-event-remarks__values">{t('myBlockMonth.remarksDISP')}</span>
            }
          </span>
        </div>
      )}
      {/* RAP with Release */}
      {eventType === eventActivityType.RAP && pairingEvent?.release && (
        (pairingEvent?.release).map(pairingEvent => <EnhancedEventViewReleaseEvent event={pairingEvent} activityType={eventType} />)
      )}
    </>
  );
}

export default EnhancedEventViewSpecialEvent;